import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogHeaderImage } from 'foundations-components/transitional/components/DialogHeaderImage';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import TrackRender from 'growth-payments-core/usage-tracker/TrackRender';
import { events } from 'growth-payments-core/usage-tracker/events';
import { TrackedLoadingButton } from 'growth-payments-core/usage-tracker/components/Button';
import { useCleanupScopedLocalStorage } from 'growth-payments-core/localStorage/useLocalStorageState';
import { useEffect } from 'react';
import { Metrics } from '../../utils/metrics';
import { useFallbackModalRedirect } from '../../hooks/modalProps';
import { useIsUngatedForKycEmbeddedFallbackExperience } from 'growth-payments-core/auth/gates';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TEST_IDS = {
  KYC_FALLBACK_MODAL_VERIFY: 'kyc-fallback-modal-verify',
  KYC_FALLBACK_MODAL: 'kyc-fallback-modal'
};
const StripeApplicationFallbackModal = ({
  businessTypeDetails,
  onClose
}) => {
  const {
    businessType,
    businessStructure
  } = businessTypeDetails;
  const {
    redirect,
    isButtonError,
    isButtonLoading
  } = useFallbackModalRedirect({
    businessType,
    businessStructure
  });
  const isUngatedForKycEmbeddedFallbackExperience = useIsUngatedForKycEmbeddedFallbackExperience();
  const cleanupScopedLocalStorage = useCleanupScopedLocalStorage(['kyc-step-stack', 'hs-payments-kyc']);
  const handleClick = () => {
    cleanupScopedLocalStorage();
    if (isUngatedForKycEmbeddedFallbackExperience) {
      onClose();
    } else {
      redirect();
    }
  };
  useEffect(() => {
    if (businessType) {
      Metrics.counter('stripe-fallback-modal-viewed', {
        businessType,
        businessStructure: businessStructure || ''
      }).increment();
    }
  }, [businessStructure, businessType]);
  return /*#__PURE__*/_jsxs(Modal, {
    centered: true,
    use: "info",
    width: 500,
    "data-test-id": TEST_IDS.KYC_FALLBACK_MODAL,
    children: [/*#__PURE__*/_jsx(TrackRender, {
      event: events.growthPaymentsPageView,
      properties: {
        screen: 'stripe-application-fallback-modal'
      }
    }), /*#__PURE__*/_jsx(DialogHeaderImage, {
      offsetBottom: -30,
      offsetTop: 59,
      children: /*#__PURE__*/_jsx(Illustration, {
        alt: I18n.text('altText.trafficCone'),
        name: "cone",
        width: 118
      })
    }), /*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "stripeSubmissionFallbackModal.header"
        })
      })
    }), /*#__PURE__*/_jsxs(DialogBody, {
      textAlign: "start",
      children: [/*#__PURE__*/_jsx(Text, {
        marginBlockEnd: "300",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "stripeSubmissionFallbackModal.body1"
        })
      }), /*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "stripeSubmissionFallbackModal.body2"
        })
      })]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      align: "center",
      children: /*#__PURE__*/_jsx(TrackedLoadingButton, {
        event: events.paymentSettingsInteraction,
        trackingProperties: {
          action: 'stripeApplicationFallbackRedirectButtonClicked'
        },
        "data-test-id": TEST_IDS.KYC_FALLBACK_MODAL_VERIFY,
        use: "primary",
        loading: isButtonLoading,
        failed: isButtonError,
        onClick: handleClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "stripeSubmissionFallbackModal.primaryCta"
        })
      })
    })]
  });
};
export default StripeApplicationFallbackModal;